import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Image } from 'antd';

import './header.css';

const icon = require('../../assets/sport_logo.png');

const Header = () => {
    const company = useSelector((s) => s.company);

    return (
        <div className='header-logo'>
            <Link to='/home'>
                <Image
                    className='header-logo-img'
                    src={(company && company.logoImage) || icon}
                    preview={false}
                    alt={company?.name || 'logo'}
                />
            </Link>
        </div>
    );
};

export default Header;
